module.exports = __webpack_public_path__ + "voice.png?8c18474d28dbb6db68e31fcfff23812b";